import { render, staticRenderFns } from "./repairTypeUserList.vue?vue&type=template&id=4c654852&scoped=true"
import script from "./repairTypeUserList.vue?vue&type=script&lang=js"
export * from "./repairTypeUserList.vue?vue&type=script&lang=js"
import style0 from "./repairTypeUserList.vue?vue&type=style&index=0&id=4c654852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c654852",
  null
  
)

export default component.exports